import React from 'react';
import type { ViewStyle } from 'react-native';
import { TouchableOpacity, View, Platform, StyleSheet } from 'react-native';
import type { ImagePickerAsset } from 'expo-image-picker';

interface ImagePickerProps {
	style?: ViewStyle;
	pickImage?: () => void;
	children?: React.ReactNode;
	title?: string;
	updateImageProfile?: (result: ImagePickerAsset) => void;
}

export default function ImagePicker({ style, pickImage, children }: ImagePickerProps) {
	const touchable = (
		<TouchableOpacity style={style} onPress={pickImage}>
			{children}
		</TouchableOpacity>
	);

	if (Platform.OS === 'ios') {
		return <View style={styles.wrap}>{touchable}</View>;
	}

	return touchable;
}

const styles = StyleSheet.create({
	wrap: {},
});
